var map = {
	"./ADMINISTRADOR.jpg": "27b0",
	"./CGU.jpg": "9f14",
	"./CONDONACIONES.jpg": "e518",
	"./ELECTORAL.jpg": "9746",
	"./OFICIOS.jpg": "a075",
	"./PRESUPUESTO.jpg": "1ff4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "19e9";